/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import { Box, Button, Paper } from "@mui/material";
import CaseDetailsStyles from "./CaseDetailsStyles";
import Typography from "@mui/material/Typography";
import CaseDetailsItem from "../../../../components/Serviceworld/Common/CaseDetailsItem/CaseDetailsItem";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type CaseDetailsProps = {
  caseItem: AbstractCase;
};

const CaseDetails = ({ caseItem }: CaseDetailsProps) => {
  const [showExpandedInfo, setShowExpandedInfo] = useState(false);

  const handleExpandInfoClick = () => {
    setShowExpandedInfo(!showExpandedInfo);
  };

  const renderAccusationSpecificInformation = (caseItem: AbstractCase) => {
    switch (caseItem.accusation) {
      case "distance":
        return (
          <>
            <CaseDetailsItem caseData={caseItem} fieldPath={"speed"} />
            <CaseDetailsItem caseData={caseItem} fieldPath={"distance"} />
          </>
        );
      case "red_light":
        return (
          <>
            <CaseDetailsItem caseData={caseItem} fieldPath={"roadUsersEndangered"} />
            <CaseDetailsItem caseData={caseItem} fieldPath={"damage"} />
            <CaseDetailsItem caseData={caseItem} fieldPath={"redLight"} />
          </>
        );
      case "speeding":
        return (
          <>
            <CaseDetailsItem caseData={caseItem} fieldPath={"locality"} />
            <CaseDetailsItem caseData={caseItem} fieldPath={"speeding"} />
          </>
        );
      case "other":
        return (
          <>
            <CaseDetailsItem caseData={caseItem} fieldPath={"caseItem.accusationOther"} />
            <CaseDetailsItem caseData={caseItem} fieldPath={"vehicle"} />
          </>
        );
      default:
        break;
    }
  };
  const renderMainInformation = (caseItem: AbstractCase) => {
    return (
      <>
        <CaseDetailsItem caseData={caseItem} fieldPath={"accusation"} />
        {renderAccusationSpecificInformation(caseItem)}
      </>
    );
  };
  const renderExpandableInformation = (caseItem: AbstractCase) => {
    return (
      <>
        <Typography variant={"h6"} sx={CaseDetailsStyles.subheader}>
          Zum Fahrer
        </Typography>

        <Box sx={CaseDetailsStyles.divider} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"driversLicensePeriod"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"flensburgPoints"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"flashed"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"driversLicenseIndispensable"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"authorityNotification"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"legalExpenseInsurance"} />

        {caseItem.legalExpenseInsurance === true && caseItem.caseInsurance.insurancePolicyNumber && (
          <CaseDetailsItem caseData={caseItem} fieldPath={"caseInsurance.insurancePolicyNumber"} />
        )}
        {caseItem.legalExpenseInsurance === true && caseItem.caseInsurance.caseReferenceNumber && (
          <CaseDetailsItem caseData={caseItem} fieldPath={"caseInsurance.caseReferenceNumber"} />
        )}
        <Typography variant={"h6"} sx={CaseDetailsStyles.subheader}>
          Persönliche Angaben
        </Typography>
        <Box sx={CaseDetailsStyles.divider} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"client.gender"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"client.givenName"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"client.familyName"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"customer.email"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"customer.telephone"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"client.residenceAddress.streetAddress"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"client.residenceAddress.postalCode"} />
        <CaseDetailsItem caseData={caseItem} fieldPath={"client.residenceAddress.addressLocality"} />
      </>
    );
  };

  return (
    <Paper elevation={4} sx={CaseDetailsStyles.container}>
      <Typography variant={"h4"} sx={CaseDetailsStyles.boxHeadingData}>
        Meine Angaben
      </Typography>
      <Typography variant={"h6"} sx={CaseDetailsStyles.subheader}>
        Verstoß
      </Typography>
      <Box sx={CaseDetailsStyles.divider} />
      {renderMainInformation(caseItem)}
      {showExpandedInfo && renderExpandableInformation(caseItem)}
      <Button fullWidth sx={CaseDetailsStyles.buttonShowMore} color={"primary"} onClick={handleExpandInfoClick}>
        {!showExpandedInfo ? "Alle Anzeigen" : "Weniger Anzeigen"}
      </Button>
    </Paper>
  );
};

export default CaseDetails;
